const SHADOW_MAIL = {
  slug: "shadow-mail",
  name: "Shadow Mail",
  description: "Darkened with obsidian dust",
  rarity: "common",
  slot: "armor",
  shopCategory: "metal-armor",
  statChanges: [
    { stat: "armor", value: 8 },
    { stat: "blackColor", value: 3 }
  ],
  sprite: {
    sheet: "wardrobe/metal/metal_black",
    frameIndex: 0
  },
  bodySprite: "characters/body/body_black",
  tags: ["daily-rotation", "metal"]
};
export {
  SHADOW_MAIL
};
//# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsiLi4vLi4vLi4vLi4vLi4vLi4vbGliL2l0ZW1zL2FybW9ycy9tZXRhbC9zaGFkb3ctbWFpbC50cyJdLAogICJzb3VyY2VzQ29udGVudCI6IFsiaW1wb3J0IHsgSXRlbURlZmluaXRpb24gfSBmcm9tICcuLi8uLi90eXBlcyc7XG5cbmV4cG9ydCBjb25zdCBTSEFET1dfTUFJTDogSXRlbURlZmluaXRpb24gPSB7XG4gIHNsdWc6ICdzaGFkb3ctbWFpbCcsXG4gIG5hbWU6ICdTaGFkb3cgTWFpbCcsXG4gIGRlc2NyaXB0aW9uOiAnRGFya2VuZWQgd2l0aCBvYnNpZGlhbiBkdXN0JyxcbiAgcmFyaXR5OiAnY29tbW9uJyxcbiAgc2xvdDogJ2FybW9yJyxcbiAgc2hvcENhdGVnb3J5OiAnbWV0YWwtYXJtb3InLFxuICBzdGF0Q2hhbmdlczogW1xuICAgIHsgc3RhdDogJ2FybW9yJywgdmFsdWU6IDggfSxcbiAgICB7IHN0YXQ6ICdibGFja0NvbG9yJywgdmFsdWU6IDMgfSxcbiAgXSxcbiAgc3ByaXRlOiB7XG4gICAgc2hlZXQ6ICd3YXJkcm9iZS9tZXRhbC9tZXRhbF9ibGFjaycsXG4gICAgZnJhbWVJbmRleDogMCxcbiAgfSxcbiAgYm9keVNwcml0ZTogJ2NoYXJhY3RlcnMvYm9keS9ib2R5X2JsYWNrJyxcbiAgdGFnczogWydkYWlseS1yb3RhdGlvbicsICdtZXRhbCddLFxufTtcbiJdLAogICJtYXBwaW5ncyI6ICJBQUVPLE1BQU0sY0FBOEI7QUFBQSxFQUN6QyxNQUFNO0FBQUEsRUFDTixNQUFNO0FBQUEsRUFDTixhQUFhO0FBQUEsRUFDYixRQUFRO0FBQUEsRUFDUixNQUFNO0FBQUEsRUFDTixjQUFjO0FBQUEsRUFDZCxhQUFhO0FBQUEsSUFDWCxFQUFFLE1BQU0sU0FBUyxPQUFPLEVBQUU7QUFBQSxJQUMxQixFQUFFLE1BQU0sY0FBYyxPQUFPLEVBQUU7QUFBQSxFQUNqQztBQUFBLEVBQ0EsUUFBUTtBQUFBLElBQ04sT0FBTztBQUFBLElBQ1AsWUFBWTtBQUFBLEVBQ2Q7QUFBQSxFQUNBLFlBQVk7QUFBQSxFQUNaLE1BQU0sQ0FBQyxrQkFBa0IsT0FBTztBQUNsQzsiLAogICJuYW1lcyI6IFtdCn0K
